export const initialState = {
  boolMap: {}, // @todo - this is no longer a bool map, but a map of users by user name, need to update references.
  psqlGroupnames: {},
	isLoading: false,
	isLoaded: false,
	errorMessage: undefined
};

export default initialState;
